import { useTranslation } from 'react-i18next';
import { useGetMediaSearch } from '@sendible/frontendv2/src/models/mediaSearch';
import { useComposeBoxContext } from '../../../composeBoxContext';
import { CommonMediaSearchModal } from '../CommonMediaSearchModal';

export const PexelsModal = () => {
  const { setIsPexelsModalOpen } = useComposeBoxContext();
  const { t } = useTranslation(['compose_box', 'common_terms']);
  const useSearchHook = (query: string) => useGetMediaSearch(query, 'Pexels');

  return (
    <CommonMediaSearchModal
      onClose={() => setIsPexelsModalOpen(false)}
      icon="pexels"
      label={t('pexels', { ns: 'common_terms' }) as string}
      searchLabel={t('search_photos') as string}
      importButtonLabel={(count) => (count === 1 ? (t('import_image') as string) : (t('import_images', { count }) as string))}
      useSearchHook={useSearchHook}
    />
  );
};
